import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-tracker-counter',
    templateUrl: './tracker-counter.component.html',
    styleUrls: ['./tracker-counter.component.css'],
    standalone: false
})
export class TrackerCounterComponent implements OnInit {
  @Input() title!: string
  @Input() value!: number

  constructor() { }

  ngOnInit(): void {
  }

}
